import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { getServices } from "@/lib/api";

function App() {
  const [services, setServices] = useState([]);
  const [preselect, setPreselect] = useState(null);

  const loadServices = useCallback(async () => {
    try {
      const data = await getServices();
      setServices(data);
    } catch (e) {
      console.error("Failed to load services", e);
    }
  }, []);

  useEffect(() => {
    loadServices();
  }, [loadServices]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const bookService = (id) => {
    if (id) setPreselect(id);
    setTimeout(() => scrollTo("booking"), 60);
  };

  return (
    <div className="App grain bg-[#050505] text-white">
      <Toaster theme="dark" position="top-center" richColors />
      <Navbar onBook={() => bookService(null)} />
      <main>
        <Hero onBook={() => bookService(null)} onExplore={() => scrollTo("services")} />
        <Marquee />
        <Manifesto />
        <Services services={services} onBook={bookService} onRefresh={loadServices} />
        <div id="reviews" />
        <Booking
          services={services}
          preselectId={preselect}
          onConsumePreselect={() => setPreselect(null)}
        />
      </main>
      <Footer onBook={() => bookService(null)} />
    </div>
  );
}

export default App;
